module.exports = __webpack_public_path__ + "static/media/ThePowerOfNature.c8d35428.mp3";